module.exports = __webpack_public_path__ + "img/官网-V1_11.2aaedd72.png";